import { format, formatDistanceToNow } from 'date-fns';

const isValidDateInput = (value: unknown): value is number | string | Date => {
  if (value == null) return false;
  const d = value instanceof Date ? value : new Date(value as number | string);
  return !isNaN(d.getTime());
};

export const safeFormat = (
  value: unknown,
  pattern: string,
  fallback: string = '—'
): string => {
  if (!isValidDateInput(value)) return fallback;
  try {
    return format(value as number | string | Date, pattern);
  } catch {
    return fallback;
  }
};

export const safeDistanceToNow = (
  value: unknown,
  options?: Parameters<typeof formatDistanceToNow>[1],
  fallback: string = '—'
): string => {
  if (!isValidDateInput(value)) return fallback;
  try {
    return formatDistanceToNow(value as number | string | Date, options);
  } catch {
    return fallback;
  }
};
